var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _vm.$q.platform.is.desktop
        ? _c("q-table", {
            ref: "table",
            staticClass: "shadow-0",
            attrs: {
              pagination: _vm.server_pagination,
              data: _vm.materials,
              columns: _vm.columns,
              loading: _vm.loading,
              "row-key": "id",
              "no-data-label": _vm.$t("no_data_avaliable"),
              "no-results-label": _vm.$t("no_results_found"),
              "loading-label": _vm.$t("loading_data"),
              "rows-per-page-label": _vm.$t("items_per_page"),
              "rows-per-page-options": [0],
              "hide-bottom": ""
            },
            on: {
              "update:pagination": function($event) {
                _vm.server_pagination = $event
              },
              request: _vm.requestMaterials
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "header",
                  fn: function(props) {
                    return _c(
                      "q-tr",
                      { attrs: { props: props } },
                      _vm._l(props.cols, function(col) {
                        return _c(
                          "q-th",
                          { key: col.name, attrs: { props: props } },
                          [
                            _vm._v(
                              "\n            " +
                                _vm._s(_vm.$t(col.label)) +
                                "\n            "
                            )
                          ]
                        )
                      }),
                      1
                    )
                  }
                },
                {
                  key: "body",
                  fn: function(props) {
                    return [
                      _c(
                        "q-tr",
                        {
                          staticClass: "cursor-pointer",
                          attrs: { props: props },
                          nativeOn: {
                            click: function($event) {
                              return _vm.showModal(props.row)
                            }
                          }
                        },
                        [
                          _c(
                            "q-td",
                            { key: "title", attrs: { props: props } },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(props.row.title) +
                                  "\n                "
                              )
                            ]
                          ),
                          _c(
                            "q-td",
                            {
                              key: "extension",
                              staticClass: "uppercase",
                              attrs: { props: props }
                            },
                            [
                              _c("q-icon", {
                                staticClass: "q-mr-sm",
                                attrs: {
                                  name: _vm.$extensionIcon(props.row.extension)
                                }
                              }),
                              _vm._v(
                                " " +
                                  _vm._s(props.row.extension) +
                                  "\n                "
                              )
                            ],
                            1
                          ),
                          _c("q-td", { key: "size", attrs: { props: props } }, [
                            _vm._v(
                              "\n                    " +
                                _vm._s(props.row.size) +
                                "\n                "
                            )
                          ]),
                          _c(
                            "q-td",
                            {
                              key: "hits",
                              attrs: { props: props, "auto-width": "" }
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(props.row.hits) +
                                  "\n                "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ]
                  }
                }
              ],
              null,
              false,
              227412838
            )
          })
        : _vm._e(),
      _vm._l(_vm.materials, function(mat, index) {
        return _vm.$q.platform.is.mobile
          ? _c(
              "q-card",
              { key: index, staticClass: "bg-grey-1 q-mb-lg cursor-pointer" },
              [
                _c("q-card-main", { staticClass: "relative-position" }, [
                  _c("div", {
                    staticClass: "line-card bg-primary absolute-top"
                  }),
                  _c("div", { staticClass: "row gutter-sm" }, [
                    _c("div", { staticClass: "col-12" }, [
                      _c("p", { staticClass: "q-subheading" }, [
                        _vm._v(_vm._s(mat.title))
                      ])
                    ])
                  ])
                ]),
                _c("q-card-separator"),
                _c(
                  "q-card-actions",
                  { staticClass: "justify-center" },
                  [
                    _c("q-btn", {
                      attrs: { flat: "", label: mat.size, icon: "fal fa-hdd" }
                    }),
                    _c("q-btn", {
                      attrs: {
                        flat: "",
                        label: mat.hits,
                        icon: "fal fa-download"
                      }
                    }),
                    _c("q-btn", {
                      attrs: {
                        flat: "",
                        label: mat.extension,
                        icon: _vm.$extensionIcon(mat.extension)
                      }
                    })
                  ],
                  1
                ),
                _c("q-card-separator"),
                _c(
                  "q-card-actions",
                  { staticClass: "justify-center" },
                  [
                    _c("q-btn", {
                      staticClass: "full-width q-my-sm",
                      attrs: {
                        label: _vm.$t("download"),
                        icon: "fal fa-download",
                        color: "primary"
                      },
                      on: {
                        click: function($event) {
                          return _vm.showModal(mat)
                        }
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      }),
      _vm.materials.length == 0
        ? _c(
            "q-card",
            { staticClass: "bg-grey-1 cursor-pointer" },
            [
              _c("q-card-main", { staticClass: "relative-position" }, [
                _c("div", { staticClass: "line-card bg-primary absolute-top" }),
                _c("div", { staticClass: "row gutter-sm" }, [
                  _c("div", { staticClass: "col-12" }, [
                    _c("p", { staticClass: "q-subheading" }, [
                      _vm._v(_vm._s(_vm.$t("no_items_found")))
                    ])
                  ])
                ])
              ])
            ],
            1
          )
        : _vm._e(),
      _c("material-modal", {
        attrs: { material: _vm.material, show: _vm.show_modal },
        on: {
          hideModal: function($event) {
            return _vm.hideModal()
          }
        }
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }